import apiUrl from '../../../utils/settings';

export const AllProducts = () => {
  return apiUrl + `/products/get/`;
};
export const AllStateUrl = () => {
  return apiUrl + '/onboarding/get/all-state';
};

export const UserByPhoneNumberUrl = () => {
  return apiUrl + '/users/get/user_details_by_phone';
};

export const AddDistributorInvoiceUrl = () => {
  return apiUrl + '/user-invoices/add-invoice-details';
};
export const EditDistributorInvoiceUrl = () => {
  return apiUrl + '/user-invoices/edit';
};

export const EditVerifiedInvoicesUrl = () => {
  return apiUrl + '/user-invoices/edit-verified-invoice';
};

export const UploadInvoiceFiles = () => {
  return apiUrl + '/invoices/upload-files';
};
export const GetUserInvoiceUrl = () => {
  return apiUrl + '/user-invoices/get';
};
export const GetUserInvoicePaginUrl = () => {
  return apiUrl + '/user-invoices/get-invoices-paginated';
};
export const OnboardingExstUsrUrl = () => {
  return apiUrl + '/onboarding/through-existing-user';
};
export const GetSingleProductUrl = () => {
  return apiUrl + '/products/get';
};
export const GetInventoryUrl = () => {
  return apiUrl + '/user-inventory/get';
};

export const GetCompanyWiseInventoryDataUrl = () => {
  return apiUrl + '/user-inventory/company-wise-inventory';
};
export const GetGapDetailsListUrl = () => {
  return apiUrl + '/company-gap-benefits/get-monthly-gap-amount-paginated';
};
export const GetCompanyProductInventoryWithIdUrl = () => {
  return apiUrl + '/user-inventory/get-inventory-for-product-company-id';
};
export const totalSaleTotalBuyReportsUrl = () => {
  return apiUrl + '/user-analytics/get-user-financial-buy-sell-data';
};
export const getDispatchPlanningReportUrl = () => {
  return apiUrl + '/order-booking/get-po-data-yearly-wise';
};
export const getReportsCSVFileUrl = () => {
  return apiUrl + '/user-orders/get-distributor-ship-to-party-report';
};
export const getReportsCSVFileForRetailerUrl = () => {
  return apiUrl + '/user-orders/get-user-financial-buy-sell-data-report';
};
export const monthlySaleTotalBuyReportsUrl = () => {
  return apiUrl + '/user-analytics/daily-buy-data';
};
export const GetProductWiseinventoryDataUrl = () => {
  return apiUrl + '/user-inventory/paginated';
};
export const GetTransactionUrl = () => {
  return apiUrl + '/user-inventory-transactions/get';
};
export const sellProductWithProductCompanyIdUrl = () => {
  return apiUrl + '/user-invoices/sell-product-with-product-company-id';
};
export const AddDistributorSellInvoiceUrl = () => {
  return apiUrl + '/user-invoices/sell-product';
};
export const GetUserInvoiceFileUrl = () => {
  return apiUrl + '/invoices/get-invoice-files';
};
export const deleteInvoiceFileUrl = () => {
  return apiUrl + '/user-invoices/delete';
};

export const UploadUserFilesUrl = () => {
  return apiUrl + '/users-file/upload-users-id-proof';
};

export const CompanyDetailsByPhoneNumberUrl = () => {
  return apiUrl + '/company/get-company-details';
};
export const searchCompanyUrl = () => {
  return apiUrl + '/company/search';
};
export const getAddressOfDeliveryToUserUrl = () => {
  return apiUrl + '/user-orders/get-delivery-address-by-company';
};
export const CompanyDetailsByCompanyNameUrl = () => {
  return apiUrl + '/company/get-details-by-name-phone/';
};
export const GetUserInvoiceUploadsUrl = () => {
  return apiUrl + '/invoices/get-invoice-file';
};

export const AllCompanyUrl = () => {
  return apiUrl + '/company/search-company-by-name';
};

export const AllProductsUrl = () => {
  return apiUrl + '/products/get-products';
};

export const CompanyTypesUrl = () => {
  return apiUrl + '/company/get-companies-by-type-list';
};

/// EasebuzzCheckout pay order api urls

// create Order
export const createOrderUrl = () => {
  return apiUrl + '/user-orders/create-order';
};

export const compareProductPricesBetweenTwoStatesUrl = () => {
  return (
    apiUrl + '/product-prices/compare-product-prices-between-two-districts'
  );
};

// get Invoice of Order
export const getOrderInvoicesUrl = () => {
  return apiUrl + '/user-orders/get-invoices';
};

// edit order
export const editOrderUrl = () => {
  return apiUrl + '/user-orders/modify-order';
};

export const updatePaymentStatusUrl = () => {
  return apiUrl + '/user-orders/update-payment-status';
};

// fetch order with order id
export const fetchOrderUrl = () => {
  return apiUrl + '/order';
};

// fetch orders with company ids
export const fetchAllOrderUrl = () => {
  return apiUrl + '/order/company';
};

// update order status with order id
export const updateOrderStatusUrl = () => {
  return apiUrl + '/user-orders/update-order-status-distributor';
};
//delete DP order
export const deleteOrderUrl = () => {
  return apiUrl + '/user-orders/delete-order';
};
// update order status after payment with order id
export const statusUpdateAfterPayUrl = () => {
  return apiUrl + '/order/status';
};

// retry for payment with order id
export const retryPaymentUrl = () => {
  return apiUrl + '/user-orders/retry-payment';
};

export const GetUserPhotoUrl = (userId = null) => {
  var url = apiUrl + '/users-file/get-user-photo';
  if (userId) {
    url = `${url}/${userId}`;
  }
  return url;
};

export const orderInvoiceDataUrl = () => {
  return apiUrl + '/order-invoice/update-order-invoice';
};

export const orderInvoiceFilesUploadUrl = () => {
  return apiUrl + '/order-proof/upload-files';
};

export const orderRemainingProductsUrl = () => {
  return apiUrl + '/order-invoice/get-remaining-quantity';
};

export const getPaginatedOrdersUrl = () => {
  return apiUrl + '/user-orders/get-orders-paginated';
};

export const getAllOrderInvoicesUrl = () => {
  return apiUrl + '/user-invoices/get-order-invoices-paginated';
};

export const getBannerImagesUrl = () => {
  return apiUrl + '/banner_images/get/all-banner-images';
};

export const GetUserTransactionOverviewUrl = () => {
  return apiUrl + '/user-inventory-transactions/get-quantity-overview';
};
export const GetUserTransactionDetailsUrl = () => {
  return (
    apiUrl + '/user-inventory-transactions/inventory-transactions-overview'
  );
};
export const GetUserTransactionDetailsByBuyerUrl = () => {
  return (
    apiUrl +
    '/user-inventory-transactions/get-quantity-overview-by-second-party-type'
  );
};
export const getUserInventoryTransactionsStpInfoUrl = () => {
  return (
    apiUrl +
    '/user-inventory-transactions/ship-to-party-info'
  );
};
export const GetUserTransactionDetailsBrandUrl = () => {
  return (
    apiUrl +
    '/user-inventory-transactions/get-quantity-overview-by-product-companies-and-products'
  );
};

// Gifting Urls
export const GetAnnouncedGiftsProductsListUrl = () => {
  return apiUrl + '/users-gifts/announced-gift-products-list';
};
export const GetMyRetailersGiftTransactionsUrl = () => {
  return apiUrl + '/users-gifts/dealer-gifts-to-mason-through-retailer/';
};
export const UploadGiftImageUrl = () => {
  return apiUrl + '/users-gifts/upload-gift-images';
};
export const UpdateGiftStatusUrl = () => {
  return apiUrl + '/users-gifts/update-gift-transaction-status';
};
export const SendOtpToGiftRecieverUrl = () => {
  return apiUrl + '/users-gifts/send-otp-to-gift-receiver';
};
export const VerifyOtpToGiftRecieverUrl = () => {
  return apiUrl + '/users-gifts/verify-otp-send-code-of-gift';
};
export const SendOtpToMasonGiftRecieverUrl = () => {
  return apiUrl + '/users-gifts/send-otp-request-to-gift-receiver-mason';
};

// benefits
export const getBenefitsDataOfUserUrl = () => {
  return apiUrl + '/company-benefit-packages/get-benefit-details';
};

// Personal Profiler
export const addPersonalProfilerUrl = () => {
  return apiUrl + '/user-personal-profiler-management/add';
};
export const addKnowYouBetterUrl = () => {
  return apiUrl + '/v2/user/personal-profiler/';
};
export const editPersonalProfilerUrl = () => {
  return apiUrl + '/user-personal-profiler-management/edit';
};
export const editKnowYouBetterUrl = (id) => {
  return apiUrl + `/v2/user/personal-profiler/${id}`;
};

export const getAllPersonalProfilerUrl = () => {
  return apiUrl + '/user-personal-profiler-management/get';
};

//Know You Better Profiler
export const getKnowYouBetterUrl = () => {
  return apiUrl + '/v2/user/personal-profiler/';
};
export const getAllGenderUrl = () => {
  return apiUrl + '/v2/user/personal-profiler/genders/all';
};
export const getAllQualificationUrl = () => {
  return apiUrl + '/v2/user/personal-profiler/qualification/all';
};
export const getAllRelationshipUrl = () => {
  return apiUrl + '/v2/user/personal-profiler/relationships/all';
};
export const getAllLanguagesUrl = () => {
  return apiUrl + '/v2/user/personal-profiler/language/all';
};
export const getAllBloodGroupUrl = () => {
  return apiUrl + '/v2/user/personal-profiler/blood_groups/all';
};
export const getAllHealthConcernsUrl = () => {
  return apiUrl + '/v2/user/personal-profiler/health_concerns/all';
};
export const getAllMealsUrl = () => {
  return apiUrl + '/v2/user/personal-profiler/conference_meal/all';
};

// Business Profiler
export const addBusinessProfilerUrl = () => {
  return apiUrl + '/user-business-profiler-management/add';
};
export const editBusinessProfilerrUrl = () => {
  return apiUrl + '/user-business-profiler-management/edit';
};
export const getAllBusinessProfilerUrl = () => {
  return apiUrl + '/user-business-profiler-management/get';
};

//Notification
export const registerNotificationTokenUrl = (token) => {
  return apiUrl + `/user-notifications/add-new-token?token_string=${token}`;
};
export const deleteNotificationTokenUrl = (token) => {
  return (
    apiUrl +
    `/user-notifications/delete-registration-token?token_string=${token}`
  );
};

export const GetUserInsuranceCertificateUrl = () => {
  return apiUrl + '/benefit-packages/get-user-certificate-s3-image/';
};

export const GetAllUserInsuranceCertificateUrl = () => {
  return apiUrl + '/benefit-packages/get-user-certificate-image-by-company-id';
};

export const getAmountForMedicalInsuranceUrl = () => {
  return apiUrl + '/company-benefit-value/get';
};

export const GetCompanyBenefitsUrl = () => {
  return apiUrl + '/company-benefit-value/get';
};

// notifications paginated data
export const GetNotificationPaginUrl = () => {
  return (
    apiUrl + '/user-notification-history/get-notification-history-paginated'
  );
};

export const getOrderCalculationsUrl = () => {
  return apiUrl + '/user-orders/calculate-order-amount';
};

export const getPhoneNumberViaGstinUrl = () => {
  return apiUrl + '/user-pan-and-gst/get-phone-no-by-gstin';
};
export const getPhoneNumberViaPanUrl = () => {
  return apiUrl + '/user-pan-and-gst/get-phone-no-by-pan';
};
export const getLedgerDueAmountUrl = () => {
  return apiUrl + '/ledger-balance/ledger-due-amount';
};
export const getCheckIfLedgerBalanceFileUrl = () => {
  return apiUrl + '/download-external-system-file/download/{filename}';
};
export const CreateLedgerPaymentUrl = () => {
  return apiUrl + '/ledger-transaction';
};
export const getLedgerBalanceUrl = () => {
  return apiUrl + '/ledger-balance/get';
};
export const getLedgerTransUrl = () => {
  return apiUrl + '/ledger-transaction/paginated';
};
export const updateLedgerPaymentUrl = () => {
  return apiUrl + '/ledger-transaction';
};
export const getSkuMasterUrl = () => {
  return apiUrl + '/products/filter';
};
